import type {FieldFailure} from "@/utils/fieldValidation"
import type {ItemAccess} from "@/types/Idea"

export type Instance = {
    _identifier: string
    _instance: number
    /** Id da situação no fluxo. Ausente significa "na inicial", que é como o item nasce. */
    _state?: number
    _rels: {
        [x: string]: Array<Instance>
    }
    /** O que o item, como está gravado, viola — só quando a leitura pediu `meta: failures`. */
    _failures?: FieldFailure[]
    /** O que quem olha pode fazer com o item — só quando a coleção tem fórmula de acesso. */
    _access?: ItemAccess
    /**
     * Quantos itens de cada relacionamento quem olha não vê: o servidor os tira da resposta — nem o
     * id vem — e manda só a contagem, para a tela dizer "+N itens ocultos".
     */
    _hidden?: { [alias: string]: number }
    /** Quem criou e quem alterou por último — o id da conta, achado nas pessoas do ambiente. */
    _createdBy?: number
    _updatedBy?: number
    /** Quando — só quando a leitura pediu `meta: createdAt`/`updatedAt`. Iguais num item nunca alterado. */
    _createdAt?: string
    _updatedAt?: string
    /** Desde quando está na situação — só com `meta: stateChangedAt`. */
    _stateChangedAt?: string
    [k: string]: any
}

export function emptyInstance(): Instance {
    return {_identifier: "", _instance: 0, _rels: {}}
}
export default Instance